import { render } from "./Step2.vue?vue&type=template&id=317aa6c6"
import script from "./Step2.vue?vue&type=script&lang=ts"
export * from "./Step2.vue?vue&type=script&lang=ts"
script.render = render

export default script